export const MODULE = {
    dashboard: 'DASHBOARD',
    history: 'HISTORY',
    question: 'QUESTION',
    dashboard2: 'DASHBOARD2',
    faq: 'FAQ',
    profile: 'PROFILE',
    contact: 'CONTACT',
    announcement: 'ANNOUNCEMENT',
    kanban: 'KANBAN',
    companyProfile: 'COMPANY_PROFILE',
    executive: 'EXECUTIVER_TEAM_MEMBER',
    myTeam: 'MY_TEAM',
    myTeamDetail: 'MY_TEAM_DETAIL',
    questionRegistry: 'QUESTION_REGISTRY',
    calendar: 'CALENDAR',
    notification: 'NOTIFICATION',
    Forbidden: 'FORBIDDEN',
    stripeError: 'STRIPE_ERROR',
    stripeSuccess: 'STRIPE_SUCCESS',
    forgotPassword: 'FORGOT_PASSWORD',
    register: 'REGISTER',
    plan: 'PLAN',
    updatePlan: 'UPDATE_PLAN',
    inviteTeam: 'INVITE_TEAM',
    SignInIntegration: 'SIGN_IN_EXTENSION',
    WebForm: 'WEB_FORM_INTEGRATION',
    QuestionRegistryExtension: 'QUESTION_REGISTRY_EXTENSION'
};
